import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  format(event) {
    const input = event.target
    let digits = input.value.replace(/\D/g, "")

    // Limit to 10 digits
    digits = digits.substring(0, 10)

    // Format as (XXX) XXX-XXXX
    let formatted = ""
    if (digits.length > 0) {
      formatted = "(" + digits.substring(0, 3)
    }
    if (digits.length >= 3) {
      formatted += ") " + digits.substring(3, 6)
    }
    if (digits.length >= 6) {
      formatted += "-" + digits.substring(6, 10)
    }

    input.value = formatted
  }
}
